import { PiListMagnifyingGlass, PiLockKey, PiUserCirclePlus, PiUsers } from 'react-icons/pi';
import type { NavigateFunction } from 'react-router';
import { IntlMessages } from '@/components';
import routes from '@/configs/routes';
import { Permissions } from '@/const/permissions';
import type { RbacMenuConfigItem } from './types';

export const menuConfig = (navigate: NavigateFunction): RbacMenuConfigItem[] => [
  {
    key: 1,
    icon: <PiUsers />,
    label: <IntlMessages id="sidebar-pages-rbac-users" />,
    permission: Permissions.ADMINISTRATION.USERS.USERS_LIST.VIEW_PAGE,
    onClick: () => navigate(routes.urlPageRBACUsers),
  },
  {
    key: 2,
    icon: <PiUserCirclePlus />,
    label: <IntlMessages id="ui-general-roles" />,
    permission: Permissions.ADMINISTRATION.ROLES.ROLES_LIST.VIEW_PAGE,
    onClick: () => navigate(routes.urlPageRBACRoles),
  },
  {
    key: 3,
    icon: <PiLockKey />,
    label: <IntlMessages id="ui-general-permissions" />,
    permission: Permissions.ADMINISTRATION.PERMISSIONS.VIEW_LIST,
    onClick: () => navigate(routes.urlPageRBACPermissions),
  },
  {
    key: 4,
    icon: <PiListMagnifyingGlass />,
    label: <IntlMessages id="sidebar-general-logs" />,
    permission: Permissions.ADMINISTRATION.LOGS.LIST,
    onClick: () => navigate(routes.urlPageRBACLogs),
  },
];
